"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)({
    passwordInput: {
        '& input::-ms-reveal': {
            display: 'none',
        },
        '& input::-ms-clear': {
            display: 'none',
        },
    },
});
